export default "__VITE_ASSET__bae6a769__"